module.exports = __webpack_public_path__ + "static/logo-header-1ade31e894b7d0cec37d739d89fbc2b2.png";